module.exports = __webpack_public_path__ + "static/16_storytelling.e2918f22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/16_storytelling.jpg
// module id = 488
// module chunks = 110568472390859